import { useMemo } from 'react';

import toast from 'react-hot-toast';
import { WithContext as ReactTags, SEPARATORS } from 'react-tag-input';

import classNames from 'classnames';

import styles from 'styles/Form.module.css';

export const MultiEmailInput = ({
    emails = [],
    onChange,
    allowDomain = false,
    tagsCustomStyles = {},
}) => {
    const tags = useMemo(() => {
        return emails.map((email) => ({
            id: email,
            text: email,
            className: '',
        }));
    }, [emails]);

    const handleDelete = (index) => {
        onChange?.(emails.filter((_, i) => i !== index));
    };

    const handleAddition = (tag) => {
        const regexp = new RegExp(
            `^([\\w.+-]+@)${allowDomain ? '?' : ''}[\\w.-]+\\.\\w{2,}$`
        );
        if (regexp.test(tag.text)) {
            onChange?.([...emails, tag.text]);
        } else {
            toast.error(`Invalid email address: ${tag.text}`);
        }
    };

    const handleInputBlur = (value) => {
        if (value) {
            handleAddition({ id: value, text: value, className: '' });
        }
    };

    return (
        <ReactTags
            tags={tags}
            separators={[
                SEPARATORS.ENTER,
                SEPARATORS.COMMA,
                SEPARATORS.SPACE,
                SEPARATORS.TAB,
            ]}
            handleAddition={handleAddition}
            handleDelete={handleDelete}
            handleInputBlur={handleInputBlur}
            classNames={{
                tagInput: styles.tagsTagInput,
                tagInputField: styles.tagsTagInputField,
                selected: styles.tagsSelected,
                tag: styles.tagsTag,
                remove: classNames(
                    styles.tagsRemove,
                    'ReactTags__remove' // Bug in the library that uses the original classname
                ),
                ...tagsCustomStyles,
            }}
            placeholder=''
        />
    );
};
